module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "home"
  }, [_c('div', {
    staticClass: "wrapper as"
  }, [_vm._m(0), _vm._v(" "), _c('nav', {
    class: ['mod-navigation', _vm.pageBoolean.showMenu ? 'open' : '']
  }, [_c('div', {
    staticClass: "nav-icon",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleMenuList($event)
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', {
    class: ['lang-switch', _vm.pageBoolean.showLang ? 'open' : '']
  }, [_c('span', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleLangList($event)
      }
    }
  }, [_vm._v("ZH-CN")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('ul', {
    staticClass: "menuList"
  }, _vm._l((_vm.meanList), function(item, index) {
    return _c('li', [_c('a', {
      class: [item.select ? 'active' : '', , item.clicked ? 'active' : ''],
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.navigatorTo(index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.text))])])])
  })), _vm._v(" "), _c('ul', {
    staticClass: "metaList"
  }, [_vm._m(2), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "tool"
    }
  }, [_c('span', [_vm._v("黑工具导航(已开放)")])])], 1), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _c('div', {
    staticClass: "pagecontrol"
  }, [_c('div', {
    staticClass: "tool-tip-wrapper"
  }, _vm._l((_vm.meanList), function(item, index) {
    return _c('span', {
      class: ['tool-tip', item.select ? 'active' : '']
    }, [_vm._v(_vm._s(item.text))])
  })), _vm._v(" "), _c('ol', {
    staticClass: "pager"
  }, _vm._l((_vm.meanList), function(item, index) {
    return _c('li', {
      on: {
        "mouseover": function($event) {
          _vm.mouseOverForSmall(index)
        },
        "mouseout": function($event) {
          _vm.mouseOutForSmall(index)
        },
        "click": function($event) {
          _vm.navigatorTo(index)
        }
      }
    }, [_c('a', {
      class: [item.select ? 'active' : '', item.clicked ? 'active' : '']
    }, [_c('span', [_vm._v(_vm._s(item.text))])])])
  }))]), _vm._v(" "), _vm._v(">")]), _vm._v(" "), _c('div', {
    staticClass: "pt-perspective",
    attrs: {
      "id": "pt-main"
    }
  }, [_c('div', {
    staticClass: "content main page-start"
  }, [_c('home', {
    attrs: {
      "page-boolean": _vm.pageBoolean,
      "mean-list": _vm.meanList
    }
  }), _vm._v(" "), _c('intro', {
    attrs: {
      "page-boolean": _vm.pageBoolean,
      "mean-list": _vm.meanList
    }
  }), _vm._v(" "), _c('advantage', {
    attrs: {
      "page-boolean": _vm.pageBoolean,
      "mean-list": _vm.meanList
    }
  }), _vm._v(" "), _c('contact', {
    attrs: {
      "page-boolean": _vm.pageBoolean,
      "mean-list": _vm.meanList
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    class: ['mod-overlay-loading', _vm.pageBoolean.showLoad ? 'startload' : '']
  }, [_vm._m(10)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mod-logo"
  }, [_c('a', {
    staticClass: "logo",
    attrs: {
      "href": "start.html"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "src": require("../../static/images/logo.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "arrow"
  }), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/de-DE/start.html"
    }
  }, [_c('span', [_vm._v("GER")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/en-DE/start.html"
    }
  }, [_c('span', [_vm._v("ENG")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/es-ES/start.html"
    }
  }, [_c('span', [_vm._v("ESP")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/nl-NL/start.html"
    }
  }, [_c('span', [_vm._v("NLD")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/fi-FI/start.html"
    }
  }, [_c('span', [_vm._v("FIN")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/zh-TW/start.html"
    }
  }, [_c('span', [_vm._v("ZH-TW")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/zh-CN/start.html"
    }
  }, [_c('span', [_vm._v("ZH-CN")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/ko-KR/start.html"
    }
  }, [_c('span', [_vm._v("KOR")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/pt-BR/start.html"
    }
  }, [_c('span', [_vm._v("BRA")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/cs-CZ/start.html"
    }
  }, [_c('span', [_vm._v("CZE")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/ja-JP/start.html"
    }
  }, [_c('span', [_vm._v("JPN")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/fr-FR/start.html"
    }
  }, [_c('span', [_vm._v("FRA")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/it-IT/start.html"
    }
  }, [_c('span', [_vm._v("ITA")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/se-SE/start.html"
    }
  }, [_c('span', [_vm._v("SWE")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://www.vmartaw.com/zcc/",
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("博主的黑科技(已开放)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#metadata"
    }
  }, [_c('span', [_vm._v("音乐的聆听者")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#metadata"
    }
  }, [_c('span', [_vm._v("海贼王的男人")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#metadata"
    }
  }, [_c('span', [_vm._v("回忆的沙漏")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#metadata"
    }
  }, [_c('span', [_vm._v("环游的甜蜜时光")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#metadata"
    }
  }, [_c('span', [_vm._v("儿时的梦想")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#metadata"
    }
  }, [_c('span', [_vm._v("永不止步")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#metadata"
    }
  }, [_c('span', [_vm._v("探味人生")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arc-rotate2"
  }, [_c('div', {
    staticClass: "loader"
  }, [_c('div', {
    staticClass: "arc"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-49b38d2c!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Home.vue
// module id = 239
// module chunks = 0